import React, { useState, useEffect } from "react"; // usestate para guardar los usuarios y useeffect para ejecutar la petición a la api
import { InstitutionApi } from "../../../../../api";
import { Loader } from "semantic-ui-react";
import { map, size } from "lodash"; //importo size de lodash para saber si hay usuarios o no
import { useAuth } from "../../../../../hooks";
import { InstitutionItem } from "../InstitutionItem";
import "./InstitutionList.scss";

const institutionController = new InstitutionApi();

export function InstitutionList(props) {
  const { institutionActive, reload, onReload } = props;
  const [institutions, setinstitutions] = useState(null);
  const { user, accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setinstitutions(null); // Reiniciar el estado de los usuarios al cargar
        const response = await institutionController.getInstitutions(
          accessToken,
          user,
          institutionActive,
        );
        //console.log("Response", response);
        if (response.institutions && response.institutions.length > 0) {
          //console.log("Response", response.users);
          setinstitutions(response.institutions); // Asegúrate de asignar solo el array de usuarios
        } else {
          setinstitutions([]); // Asignar un array vacío si no hay usuarios
        }
        //console.log("Response", response);
        //console.log("Active", userActive);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [institutionActive, user, reload, accessToken]); // Si userActive o reload cambian, se ejecuta la petición

  if (!institutions) {
    return <Loader active inline="centered" />;
  }
  if (size(institutions) === 0) {
    return "No hay usuarios";
  }

  return (
    <div className="institution-list-container">
      {map(institutions, (institution) => (
        <InstitutionItem
          key={institution._id}
          institution={institution}
          onReload={onReload}
        />
      ))}
    </div>
  );
}
